<div class="dialog confirm-dialog">
  <mat-icon class="dialog__close" aria-hidden="false" aria-label="Close icon" mat-dialog-close>close</mat-icon>
  <div mat-dialog-title>
    <header *ngIf="isExceedLimit; else downloadExcel">{{ 'shared.alert' | xTranslate }}</header>
    <ng-template #downloadExcel>
      <header>{{ 'shared.download' | xTranslate }}</header>
    </ng-template>
  </div>
  <div mat-dialog-content class="confirm-container">
    <!-- VIEW MODE -->
    <div class="viewmode">
      <span><mat-icon class="mat-icon" *ngIf="isExceedLimit" svgIcon="alert-icon"></mat-icon></span>
      <span id="e2e-description">
        <div *ngIf="isExceedLimit">
          <span class="message">
            {{ 'shared.exportLimitError' | xTranslate: messageArgs }}
          </span>
        </div>
        <span *ngIf="!isExceedLimit">
          <div class="export-options">
            <span class="message-export">{{ 'shared.pleaseClickExportToDownloadExcel' | xTranslate }}</span>
            <form [formGroup]="exportOptions" class="allcolumns">
              <ol type="1" class="options-list">
                <ng-container *ngIf="exportOptions.controls?.property">
                  <li>
                    <label>
                      <span>{{ 'shared.export' | xTranslate | titlecase }}</span
                      >:</label
                    >
                    <!-- The formControlName is changed from splitRecords to property as it is used in bulkexport to define the export options since same name is used for different puropse,
                      this is causing issue to store export values in property so the name is changed to property.
                      -->
                    <mat-radio-group
                      aria-label="Select an option"
                      formControlName="property"
                      class="export-options__radiogroup"
                      (change)="splitRecordsChange($event)"
                    >
                      <mat-radio-button [value]="false">{{
                        'recordsSearch.oneRowPerRecord' | xTranslate
                      }}</mat-radio-button>
                      <mat-radio-button [value]="true">{{
                        'recordsSearch.oneRowPerSpace' | xTranslate
                      }}</mat-radio-button>
                    </mat-radio-group>
                  </li>
                </ng-container>
                <li>
                  <label>
                    <span>{{ 'shared.columnsYouNeed' | xTranslate }}:</span>
                  </label>
                  <!-- even here property formControlName  is repeated and column formControlName name is used in bulkexport to store column option, 
                   so changed here to align the changes both in clipboard and search page.The value is changed from all to null for same puropse. -->
                  <mat-radio-group
                    aria-label="Select an option"
                    formControlName="column"
                    class="export-options__radiogroup"
                  >
                    <mat-radio-button [value]="null">{{ 'shared.allColumns' | xTranslate }}</mat-radio-button>
                    <mat-radio-button [value]="`selected`"
                      >{{ 'shared.columnsOnScreen' | xTranslate }}
                    </mat-radio-button>
                  </mat-radio-group>
                </li>
                <li>
                  <label>
                    <span>{{ 'shared.exportDisplay' | xTranslate }} :</span>
                  </label>
                  <mat-radio-group
                    aria-label="Select an option"
                    formControlName="allowDuplicates"
                    class="export-options__radiogroup"
                  >
                    <!-- The values are changed for allowDuplicates from false to true and vice versa to align with the search page option while saving in local storage, since the values are defined
                   as below in bulk-export-dialog.component.html changing them.
                   -->
                    <mat-radio-button [value]="false">{{ 'shared.cleanedExportData' | xTranslate }}</mat-radio-button>
                    <mat-radio-button [value]="true">{{ 'shared.delimtedExportData' | xTranslate }}</mat-radio-button>
                  </mat-radio-group>
                </li>
                <li>
                  <label>
                    <span> {{ 'shared.downloadView' | xTranslate }}:</span>
                  </label>
                  <mat-radio-group
                    aria-label="Select an option"
                    formControlName="downloadView"
                    class="export-options__radiogroup"
                  >
                    <mat-radio-button checked value="table">{{ 'shared.tableView' | xTranslate }}</mat-radio-button>
                    <mat-radio-button value="compare">{{ 'shared.compareView' | xTranslate }}</mat-radio-button>
                  </mat-radio-group>
                </li>
              </ol>
            </form>
          </div>
        </span>
      </span>
    </div>
  </div>
  <div mat-dialog-actions>
    <button
      mat-flat-button
      color="primary"
      [disabled]="isExceedLimit || exportOptions.value?.downloadView === 'compare'"
      (click)="continueExport('csv')"
    >
      {{ 'recordsSearch.downloadCsv' | xTranslate }}
    </button>
    <button mat-flat-button color="primary" [disabled]="isExceedLimit" (click)="continueExport('xlsx')">
      {{ 'recordsSearch.downloadExcel' | xTranslate }}
    </button>
  </div>
</div>
